<template>
  <article class="whitespace-pre-line">
    <div
      v-if="showContent()"
      class="mt-12 space-y-8 rounded-3xl bg-white px-6 py-6 lg:px-8 lg:py-12">
      <div
        v-for="section in content"
        :key="section.title">
        <h2
          v-if="section.copy"
          class="text-2xl leading-tight text-gray-600 lg:text-3xl">
          {{ section.title }}
        </h2>
        <h2
          v-if="section.copy && (privacyType === 'beijing' || privacyType === 'shanghai')"
          class="text-2xl leading-tight text-gray-600 lg:text-3xl">
          {{ section.titleChinese }}
        </h2>
        <div
          v-if="section.copy"
          class="prose prose-lg mt-6 text-base font-normal text-gray-400 lg:text-lg"
          v-html="section.copy" />
      </div>
    </div>
    <div
      v-if="si"
      class="mt-12 rounded-2xl bg-gray-450 p-8 text-gray-200 ring-1 ring-gray-200/10">
      <h3 class="uppercase">
        {{ si.title }}
      </h3>
      <p class="mt-4 font-normal leading-snug">
        {{ si.content.title }}
      </p>
      <p class="font-normal leading-snug">
        {{ si.content.description }}
      </p>
    </div>
  </article>
</template>

<script setup lang="ts">
  type contentProps = {
    content: {
      responsibilities: { title: string; titleChinese: string; copy: string }
      skills: { title: string; titleChinese: string; copy: string }
      experience: { title: string; titleChinese: string; copy: string }
      offer: { title: string; titleChinese: string; copy: string }
      compensation: { title: string; titleChinese: string; copy: string }
    }
    si: {
      title: string
      content: {
        title: string
        description: string
        deadline: string | null
      }
    }
    privacyType: string
  }
  const props = defineProps<contentProps>()

  const showContent = () => {
    return Object.entries(props.content).every(item => item[1].copy !== '/')
  }
</script>
